import thumb01FlyerImg from '../../img/template_thumnail/hwp/thumb01_flyer.png';
import thumb01FlyerImg2x from '../../img/template_thumnail/hwp/thumb01_flyer@2x.png';
import thumb02invItation1Img from '../../img/template_thumnail/hwp/thumb02_invitation1.png';
import thumb02invItation1Img2x from '../../img/template_thumnail/hwp/thumb02_invitation1@2x.png';
import thumb03invItation2Img from '../../img/template_thumnail/hwp/thumb03_invitation2.png';
import thumb03invItation2Img2x from '../../img/template_thumnail/hwp/thumb03_invitation2@2x.png';
import thumb04letter1Img from '../../img/template_thumnail/hwp/thumb04_letter1.png';
import thumb04letter1Img2x from '../../img/template_thumnail/hwp/thumb04_letter1@2x.png';
import thumb05letter2Img from '../../img/template_thumnail/hwp/thumb05_letter2.png';
import thumb05letter2Img2x from '../../img/template_thumnail/hwp/thumb05_letter2@2x.png';
import thumb06MinutesImg from '../../img/template_thumnail/hwp/thumb06_minutes.png';
import thumb06MinutesImg2x from '../../img/template_thumnail/hwp/thumb06_minutes@2x.png';
import thumb07NewsLetterImg from '../../img/template_thumnail/hwp/thumb07_newsletter.png';
import thumb07NewsLetterImg2x from '../../img/template_thumnail/hwp/thumb07_newsletter@2x.png';
import thumb08OfficalDocumentImg from '../../img/template_thumnail/hwp/thumb08_officialdocument.png';
import thumb08OfficalDocumentImg2x from '../../img/template_thumnail/hwp/thumb08_officialdocument@2x.png';
import thumb09PosterImg from '../../img/template_thumnail/hwp/thumb09_poster.png';
import thumb09PosterImg2x from '../../img/template_thumnail/hwp/thumb09_poster@2x.png';
import thumb10RecepeImg from '../../img/template_thumnail/hwp/thumb10_recipe.png';
import thumb10RecepeImg2x from '../../img/template_thumnail/hwp/thumb10_recipe@2x.png';
import thumb11ReportImg from '../../img/template_thumnail/hwp/thumb11_report.png';
import thumb11ReportImg2x from '../../img/template_thumnail/hwp/thumb11_report@2x.png';
import thumb12Resume1Img from '../../img/template_thumnail/hwp/thumb12_resume1.png';
import thumb12Resume1Img2x from '../../img/template_thumnail/hwp/thumb12_resume1@2x.png';
import thumb13Resume2Img from '../../img/template_thumnail/hwp/thumb13_resume2.png';
import thumb13Resume2Img2x from '../../img/template_thumnail/hwp/thumb13_resume2@2x.png';

export const HwpTemplate = {
  templatePath: '/template/hwp/',
  width: '106px',
  height: '153px',
  items: [
    /*   {
      thumnailImage: '',
      thumnailImage2x: '',
      titlei18nID: 'HwpTemplateItems.New',
      isNew: true
    }, */
    {
      thumnailImage: thumb01FlyerImg,
      thumnailImage2x: thumb01FlyerImg2x,
      titlei18nID: 'HwpTemplateItems.TemplateFlyerTitle',
      fileName: 'Flyer.hwp'
    },
    {
      thumnailImage: thumb02invItation1Img,
      thumnailImage2x: thumb02invItation1Img2x,
      titlei18nID: 'HwpTemplateItems.TemplateInviation01Title',
      fileName: 'Invitation 1.hwp'
    },
    {
      thumnailImage: thumb03invItation2Img,
      thumnailImage2x: thumb03invItation2Img2x,
      titlei18nID: 'HwpTemplateItems.TemplateInviation02Title',
      fileName: 'Invitation 2.hwp'
    },
    {
      thumnailImage: thumb04letter1Img,
      thumnailImage2x: thumb04letter1Img2x,
      titlei18nID: 'HwpTemplateItems.TemplateLetter01Title',
      fileName: 'Letter 1.hwp'
    },
    {
      thumnailImage: thumb05letter2Img,
      thumnailImage2x: thumb05letter2Img2x,
      titlei18nID: 'HwpTemplateItems.TemplateLetter02Title',
      fileName: 'Letter 2.hwp'
    },
    {
      thumnailImage: thumb06MinutesImg,
      thumnailImage2x: thumb06MinutesImg2x,
      titlei18nID: 'HwpTemplateItems.TemplateMinutesTitle',
      fileName: 'Minutes.hwp'
    },
    {
      thumnailImage: thumb07NewsLetterImg,
      thumnailImage2x: thumb07NewsLetterImg2x,
      titlei18nID: 'HwpTemplateItems.TemplateNewsLetterTitle',
      fileName: 'Newsletter.hwp'
    },
    {
      thumnailImage: thumb08OfficalDocumentImg,
      thumnailImage2x: thumb08OfficalDocumentImg2x,
      titlei18nID: 'HwpTemplateItems.TemplateOfficialDocumentTitle',
      fileName: 'Official document.hwp'
    },
    {
      thumnailImage: thumb09PosterImg,
      thumnailImage2x: thumb09PosterImg2x,
      titlei18nID: 'HwpTemplateItems.TemplatePosterTitle',
      fileName: 'Poster.hwp'
    },
    {
      thumnailImage: thumb10RecepeImg,
      thumnailImage2x: thumb10RecepeImg2x,
      titlei18nID: 'HwpTemplateItems.TemplateRecipeTitle',
      fileName: 'Recipe.hwp'
    },
    {
      thumnailImage: thumb11ReportImg,
      thumnailImage2x: thumb11ReportImg2x,
      titlei18nID: 'HwpTemplateItems.TemplateReportTitle',
      fileName: 'Report.hwp'
    },
    {
      thumnailImage: thumb12Resume1Img,
      thumnailImage2x: thumb12Resume1Img2x,
      titlei18nID: 'HwpTemplateItems.TemplateResume01Title',
      fileName: 'Resume 1.hwp'
    },
    {
      thumnailImage: thumb13Resume2Img,
      thumnailImage2x: thumb13Resume2Img2x,
      titlei18nID: 'HwpTemplateItems.TemplateResume02Title',
      fileName: 'Resume 2.hwp'
    }
  ]
};
